import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// 頁面組件
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';
import DemoPage from './pages/DemoPage';
import NotFoundPage from './pages/NotFoundPage';

// 布局組件
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// 樣式
import './styles/globals.css';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;